import React, { useEffect } from 'react';
import { ROUTES } from '@cyberint/common-utils';
import { useRouteTitle } from '../../hooks/useRouteTitle';
import { t } from '../../i18n';

export const AsmNgTitle = ({ match }) => {
  const { title, setTitle } = useRouteTitle(match);
  const param = match?.params?.['*']?.split('/')?.[0];

  useEffect(() => {
    if (title) return;
    if (param === ROUTES.ASM_TECHNOLOGIES || match?.pathname?.endsWith(ROUTES.ASM_TECHNOLOGIES)) {
      setTitle(t('tabs.technologies'));
    } else if (param === ROUTES.ASM_EXPOSURE_ITEMS || match?.pathname?.includes(ROUTES.ASM_EXPOSURE_ITEMS)) {
      setTitle(t('tabs.exposure_items'));
    } else if (param === ROUTES.ASM_ASSETS || match?.pathname?.endsWith(ROUTES.ASM_ASSETS)) {
      setTitle(t('tabs.assets'));
    } else if (param === ROUTES.ASM_CERTIFICATES || match?.pathname?.endsWith(ROUTES.ASM_CERTIFICATES)) {
      setTitle(t('tabs.certificates'));
    } else {
      setTitle(t('common.external_attack_surface'));
    }
  }, [param]);

  return <span>{title || '...'}</span>;
};
